// import React from 'react'
// import downloadoffer from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-07.svg";
// import { useSelector } from 'react-redux';

// export const Downloads_doc = ({url}) => {
//   const state = useSelector((state) => state);
//   return (
//     <>
//     {state.ClientBranchIDs.SUBROLE == 3 || state.ClientBranchIDs.SUBROLE == 1 &&
//    state.NumberCounts.Editable == 1 ? 
//                   <p  className="m-0 d-flex align-items-center"  style={{textDecoration:"underline", color:"#234492", fontWeight:"800"}}
//                   onClick={()=>{ 
//                     window.open(url,`/blank`)
//                   }}>


//       <span>Download</span>
//                 <img
//         src={downloadoffer}
//         className="Downloading_img"
//         alt="Download Offer"
//         style={{ cursor: "pointer" }}

//       />
//                                               </p>     
//     : null}
//     </>
//   )
// }
import React from "react";
import downloadoffer from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-07.svg";
import { useSelector } from "react-redux";

export const Downloads_doc = ({ url }) => {
  const state = useSelector((state) => state);

  const handleDownload = async () => {
    if (!url) return;

    // Normalize URL if passed as object or Blob/File
    let targetUrl = url;
    if (typeof url === "object" && url !== null) {
      if (url instanceof Blob || url instanceof File) {
        targetUrl = window.URL.createObjectURL(url);
      } else {
        targetUrl = url.media_url || url.url || url.file_url || url.path || "";
      }
    }

    if (!targetUrl || typeof targetUrl !== "string") return;

    // Helper to get filename from URL
    const getFileName = (strUrl) => {
      try {
        const cleanUrl = strUrl.split("?")[0].split("#")[0];
        const name = cleanUrl.split("/").pop();
        if (name && name.includes(".")) {
          return name;
        }
      } catch (e) {
        console.error(e);
      }
      return "downloaded_file";
    };

    const fileName = getFileName(targetUrl);

    // Fallback method for cross-origin or blocked fetches
    const fallbackDownload = (fileUrl) => {
      try {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (err) {
        window.open(fileUrl, "_blank");
      }
    };

    // If already blob URL or data URL, trigger fallback immediately
    if (targetUrl.startsWith("blob:") || targetUrl.startsWith("data:")) {
      fallbackDownload(targetUrl);
      return;
    }

    // Try fetching as blob for direct download, fallback on CORS/network failure
    try {
      const response = await fetch(targetUrl);
      if (!response.ok) throw new Error(`HTTP status ${response.status}`);

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100);
    } catch (error) {
      console.warn("Fetch blob download failed, falling back to direct open:", error);
      fallbackDownload(targetUrl);
    }
  };

  const subrole = state?.ClientBranchIDs?.SUBROLE;
  const editable = state?.NumberCounts?.Editable;

  const canDownload =
    (subrole == 3 || subrole == 1) && editable == 1;

  return (
    <>
      {canDownload ? (
        <p
          className="m-0 d-flex align-items-center"
          style={{
            textDecoration: "underline",
            color: "#234492",
            fontWeight: "800",
            cursor: "pointer",
            width: "fit-content",
          }}
          onClick={handleDownload}
        >
          <span>Download</span>
          <img
            src={downloadoffer}
            className="Downloading_img ms-2"
            alt="Download Offer"
          />
        </p>
      ) : null}
    </>
  );
};
